import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FaBars, FaTimes, FaFacebookF, FaInstagram, FaLinkedinIn, FaTwitter } from 'react-icons/fa';
import './Header.css';
import logo1 from '../assets/logo.png';

const Header = () => {
  const [click, setClick] = useState(false);
  const handleClick = () => setClick(!click);

  return (
    <header>
      <div className="top-bar">
        {/* Logo & Brand */}
        <div className="top-left">
          <img src={logo1} alt="Skybreeze Logo" className="logo-img" />
          {/* <h1 className="brand-name">SKYBREEZE AC SOLUTION</h1> */}
          <h5 style={{ color: "white" }}>SKYBREEZE AC SOLUTION</h5>
        </div>

        {/* Hamburger menu for mobile */}
        <div className="mobile-icon" onClick={handleClick}>
          {click ? <FaTimes /> : <FaBars />}
        </div>

        {/* Desktop social icons */}
        <div className="top-right">
          <a href="https://www.facebook.com/profile.php?id=61587039728926" target="_blank" rel="noopener noreferrer" className="s-link fb">
            <FaFacebookF className="s-icon" />
          </a>
          <a href="https://www.instagram.com/skybreezeacsolutions2026/" target="_blank" rel="noopener noreferrer" className="s-link insta">
            <FaInstagram className="s-icon" />
          </a>
          <a href="https://www.linkedin.com/in/prakash-shanmugaraj-141a8b355/" target="_blank" rel="noopener noreferrer" className="s-link in">
            <FaLinkedinIn className="s-icon" />
          </a>
          {/* <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="s-link tw">
            <FaTwitter className="s-icon" />
          </a> */}
        </div>
      </div>

      {/* Mobile Menu (slides from top bar) */}
      <ul className={click ? 'nav-menu active' : 'nav-menu'}>
        <li><Link to="/" onClick={handleClick} >Home</Link></li>
        <li><Link to="/about" onClick={handleClick}>About Us</Link></li>
        <li><Link to="/service" onClick={handleClick}>Services</Link></li>
        <li><Link to="/projects" onClick={handleClick}>Projects</Link></li>
        <li><Link to="/products" onClick={handleClick}>Products</Link></li>
        <li><Link to="/contact" onClick={handleClick}>Contact</Link></li>
        <li><Link to="/duct" onClick={handleClick}>Duct Unit</Link></li>
        <li><Link to="/partner" onClick={handleClick}>Partner With Us</Link></li>


        {/* Optional mobile social icons */}
        <div className="mobile-menu-social">
          <a href="https://www.facebook.com/profile.php?id=61587039728926" target="_blank" rel="noopener noreferrer" className="s-link fb"><FaFacebookF className="s-icon" /></a>
          <a href="https://www.instagram.com/skybreezeacsolutions2026/" target="_blank" rel="noopener noreferrer" className="s-link insta"><FaInstagram className="s-icon" /></a>
          <a href="https://www.linkedin.com/in/prakash-shanmugaraj-141a8b355/" target="_blank" rel="noopener noreferrer" className="s-link in"><FaLinkedinIn className="s-icon" /></a>
        </div>
      </ul>
    </header>
  );
};

export default Header;
